import { render, staticRenderFns } from "./kk-result-pay.vue?vue&type=template&id=0d1a60ad&"
import script from "./kk-result-pay.vue?vue&type=script&lang=js&"
export * from "./kk-result-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports